import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { usePeriscopeMetadata } from '@hooks';

import { MetadataContainer, MetadataEntry } from '@periscopes/general/metadata';
import { PeriscopePardotAutomationRuleMetadata, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';

export interface PardotAutomationRuleMetadataTabProps {
	sonarObjectId: number;
}

export const PardotAutomationRuleMetadataTab: React.FC<PardotAutomationRuleMetadataTabProps> = ({ sonarObjectId }) => {
	const { loading, metadata } = usePeriscopeMetadata<PeriscopePardotAutomationRuleMetadata>(
		sonarObjectId,
		SonarObjectType.PardotAutomation
	);

	const metadataEntries = useMemo(() => {
		if (!metadata) {
			return [];
		}

		const entries: MetadataEntry[] = [
			{
				label: COPY_SPECIFIC.MATCH_TYPE,
				type: 'string',
				value: metadata.matchType
			},
			{
				label: COPY_SPECIFIC.REPEAT,
				type: 'string',
				value: metadata.repeat
			},
			{
				label: COPY_SPECIFIC.REAL_TIME,
				type: 'string',
				value: metadata.realTime
			}
		];

		return entries;
	}, [ metadata ]);

	if (loading) {
		return <LoadingSpinner spinning />;
	}

	return <MetadataContainer
		entries={ metadataEntries }
		title={ COPY_SPECIFIC.AUTOMATION_RULE_INFORMATION } />;
};
